import Big from 'big.js';
import { isNil } from 'lodash';

export const bankRound = (num, decimalPlaces) => {
  const factor = 10 ** decimalPlaces;
  return Math.round((num + Number.EPSILON) * factor) / factor;
};

export const renderNumber = (num: number | string): string => {
  if (typeof num === 'number') {
    return num.toLocaleString();
  }

  const parsedNum = parseFloat(num);
  if (isNaN(parsedNum)) {
    return num; // Return original string if it's not a valid number
  }

  return renderNumber(parsedNum);
};

export const parseNumToPercentage = (number: string | number, fixed = 1) => {
  if (isNil(number) || number === '' || isNaN(Number(number))) {
    return '--';
  }
  const bn = new Big(Number(number) * 100);
  const bnValue = bn.toNumber();

  if (bnValue === 100) {
    return '100%';
  }

  if (bnValue === 0) {
    return '0%';
  }

  return bn.toFixed(fixed) + '%';
};

export const formatMs = (value?: number | string) => {
  if (value == null || value === '' || isNaN(Number(value))) return value;

  const numValue = Number(value);

  return numValue >= 1000 ? `${(numValue / 1000).toFixed(0)} s` : `${numValue} ms`;
};

/**
 * 智能保留小数位，没有小数时不显示小数点
 * @param num - 要格式化的数字
 * @param decimalPlaces - 最大小数位数
 * @returns 格式化后的字符串 (例: 5, 5.6, 5.67)
 */
export const formatDecimal = (num: number | string, decimalPlaces: number = 2): string => {
  if (num === null || num === undefined || num === '' || isNaN(Number(num))) {
    return '0';
  }

  const number = Number(num);

  // 如果是整数，直接返回整数字符串
  if (Number.isInteger(number)) {
    return number.toString();
  }

  // 有小数时，保留指定位数并移除尾随的0
  const fixed = number.toFixed(decimalPlaces);
  return parseFloat(fixed).toString();
};

export const formatPercentage = (value: number) => {
  const percentage = value * 100;
  if (percentage === 0) {
    return '0%';
  }
  if (percentage < 0.01) {
    return '< 0.01%';
  }
  return `${percentage.toFixed(2)}%`;
};

// Format metric values
export const formatMetricValue = (metric: Aggregation, data: any) => {
  if (!data) return null;

  const value = data[metric?.id || ''];
  if (value === undefined || value === null) return null;

  if (metric.unit === '%') {
    // Convert to percentage if it's a decimal (0-1 range)
    return formatPercentage(value);
  }

  return typeof value === 'number' ? value.toLocaleString() : value;
};
